import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import ServerError from '../ServerError';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const ResetPassword = () => {
    const [token, setToken] = useState('');
    const [tokenValid, setTokenValid] = useState(null);
    const [newPassword, setNewPassword] = useState('');
    const [message, setMessage] = useState('');
    const [passwordUpdated, setPasswordUpdated] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        setToken(searchParams.get('token'));
        console.log(token);
    }, [location]);

    const verifyToken = async (token) => {
        try {
            const response = await fetch(`${apiBaseUrl}/verify-reset-password-token`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token }),
            });
            if (response.ok) {
                setTokenValid(true);
            } else if (response.status === 400 || response.status === 404) {
                setTokenValid(false);
            } else {
                console.log('500 response from verify reset password token endpoint.')
            }
        } catch (error) {
            console.log('verifyToken failed');
            console.error(error);
        }
    }

    useEffect(() => {
        if (token) {
            verifyToken(token);
            console.log('verifyToken called')
        }
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${apiBaseUrl}/reset-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, newPassword }),
            });
            if (response.ok) {
                setMessage('Password reset successfully');
                setPasswordUpdated(true);
            } else if (response.status === 400 || response.status === 404) {
                setTokenValid(false);
            } else {
                console.log('500 response from verify reset password token endpoint.')
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="page-background flex relative">
            <div className="bg-white p-6 rounded-lg shadow-md max-w-md mx-auto">
                {passwordUpdated ? (
                    <div>
                        <p className="text-center my-4">
                            Your password has been updated. Please log in with your new password.
                        </p>
                        <Link to="/login" className="w-full block text-center px-4 py-2 bg-blue-500 hover:bg-blue-700 text-white rounded-md">
                            Log in
                        </Link>
                    </div>
                ) : (
                    <div>
                        {tokenValid === true && (
                            <form onSubmit={handleSubmit}>
                                <input
                                    type="password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    placeholder="New Password"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                                <button type="submit" className="mt-4 w-full bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition duration-300">
                                    Reset Password
                                </button>
                                {message && <p className="mt-4 text-center">{message}</p>}
                            </form>
                        )}
                        {tokenValid === false && (
                            <p className="text-red-500 text-center">Invalid or expired token. Please request a new password reset.</p>
                        )}
                        {tokenValid === null && (
                            <p className="text-gray-500 text-center">Verifying token...</p>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ResetPassword;
